import $ from 'jquery';
import {
  dataSendJqXHR, getAreaJqXHR,
  getCountriesJqXHR, getIndustrieCategorysJqXHR,
  getIndustriesJqXHR, getMainItemCategorysJqXHR,
  getMainItemsJqXHR, getNextjoinsJqXHR, getOccupationsJqXHR, getPrefecturesJqXHR, getPriceJqXHR, getPurposeOptionsJqXHR, getRegistRouteJqXHR, getRolesJqXHR, getShowsJqXHR, getInvitationTypeJqXHR
} from '../api';
import SignupStep from '../components/SignupStep';
import { getParams } from '../util/urlParam';
import { signUpValidation } from '../util/validation';
import { exhibitioninfo, langList, proc } from '../variables';

import { Area, Countries, dataSend, IndustrieCategorys, Industries, MainItemCategorys, MainItems, Nextjoins, Occupations, Prefectures, Price, PurposeOptions, Roles, Shows, RegistRoutes, InvitationType } from '../model/index';
import { confexhi } from '../util/common';
import { storage } from '../util/storage';
import translate, { Lang, t } from '../util/translate';
import { getCookie } from '../util/cookie';
$(() => {
  
  $('#loading').show(); // ロードを開始

  $('#signup-step').html(SignupStep)
  $('#step-3').addClass('active')

  let phoneNumber = localStorage.getItem('phoneNumber')
  let emailAddress = localStorage.getItem('emailAddress')

  if(phoneNumber){
    $('#phoneNumber').val(storage.get('phoneNumber') as any)
    $('#phoneNumber').prop( 'disabled', true )
  }

  if(emailAddress){
    $('#email').val(JSON.parse(emailAddress))
    $('#email_confirm').val(JSON.parse(emailAddress))
    $('#email').prop( 'disabled', true )
    $('#email_confirm').prop( 'disabled', true )
  }

  const smsToken = getCookie('smsToken') || '';

  translate(); // 翻訳

  // クエリ取得
  const params = getParams(exhibitioninfo);

  // 言語設定 クエリ優先 -> localStorage
  let lang = 'ja' as keyof Lang
  if (langList.indexOf(String(params.lang)) !== -1) {
    lang = params.lang as keyof Lang;
    localStorage.setItem('lang', lang);
  }else{
    lang = (localStorage.getItem('lang') ?? 'ja') as keyof Lang;
  }

  // 画面読み込み時コードが入力されていたら表示する
  let vipParam = localStorage.getItem('vipParam');
  let codeParam = localStorage.getItem('codeParam');

  if (vipParam === "1" || vipParam === "2"){
    $('.formcode').text(codeParam as string);
    $('.getcode').show();
  }

  // 登録済みEmailエラー非表示
  $('#emailerrmsg').hide();

  let exhibition = String(localStorage.getItem('exhibition'));
  if(exhibition === "giftnet"){
    $('.notgift').hide();
    $('#willvisit_list').prop('required', false);
    $('#nextjoin').prop('required', false);
    $('#purpose_control').prop('required', false);
    // タイトル表示
    $('#signup_title').html(t.signup_top_gift_title[lang]);
  }else{
    // 展示会の名前を取得
    confexhi(exhibition, 1).then(exhibitionName => {
      if (exhibitionName !== "") {
        // ヘッダーへ
        let willvisitList: string = "";
        willvisitList += `<div class="">
          <label class="" >${exhibitionName}</label>
          </div>`;
        $('#willvisit_list').html(willvisitList);
        // ローカルストレージ保存
        localStorage.setItem('exhibition', exhibition);
        // タイトル表示
        $('#signup_title').html(t.signup_top_title[lang]);
      } else {
        // 選択ページへ
        window.location.href = `../selection.html`;
      }
    });
  }

  // フッター問い合わせ
  let contactlist: string = 
  `
  <dd><span>`+ t.footer_tigs[lang] + t.footertel_tigs[lang] +`</span> <a href="mailto:`+ t.footermail_tigs[lang] +`">`+ t.footermail_tigs[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_ld[lang] + t.footertel_ld[lang] +`</span> <a href="mailto:`+ t.footermail_ld[lang] +`">`+ t.footermail_ld[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_landd[lang] + t.footertel_landd[lang] +`</span> <a href="mailto:`+ t.footermail_landd[lang] +`">`+ t.footermail_landd[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_gds[lang] + t.footertel_gds[lang] +`</span> <a href="mailto:`+ t.footermail_gds[lang] +`">`+ t.footermail_gds[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_pi[lang] + t.footertel_pi[lang] +`</span> <a href="mailto:`+ t.footermail_pi[lang] +`">`+ t.footermail_pi[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_osaka[lang] + t.footertel_osaka[lang] +`</span> <a href="mailto:`+ t.footermail_osaka[lang] +`">`+ t.footermail_osaka[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_fukuoka[lang] + t.footertel_fukuoka[lang] +`</span> <a href="mailto:`+ t.footermail_fukuoka[lang] +`">`+ t.footermail_fukuoka[lang] +`</a>)</dd>
  `
  $('#box_officework').html(contactlist);

  // APIデータ取得
  const prefecturesJqXHR = getPrefecturesJqXHR();
  const industrieCategorysJqXHR = getIndustrieCategorysJqXHR();
  const industriesJqXHR = getIndustriesJqXHR();
  const occupationsJqXHR = getOccupationsJqXHR();
  const mainItemCategorysJqXHR = getMainItemCategorysJqXHR();
  const mainItemsJqXHR = getMainItemsJqXHR();
  const rolesJqXHR = getRolesJqXHR();
  const priceJqXHR = getPriceJqXHR();
  const areaJqXHR = getAreaJqXHR();
  const countriesJqXHR = getCountriesJqXHR();
  const showsJqXHR = getShowsJqXHR();
  const nextjoinsJqXHR = getNextjoinsJqXHR();
  const purposeOptionsJqXHR = getPurposeOptionsJqXHR();
  const registRouteJqXHR = getRegistRouteJqXHR();
  const invitationTypeJqXHR = getInvitationTypeJqXHR();
  $.when(prefecturesJqXHR, industriesJqXHR, occupationsJqXHR, mainItemsJqXHR, rolesJqXHR, priceJqXHR, areaJqXHR, countriesJqXHR, showsJqXHR, industrieCategorysJqXHR, mainItemCategorysJqXHR, nextjoinsJqXHR, purposeOptionsJqXHR, registRouteJqXHR, invitationTypeJqXHR)
    .done((jqPrefectures, jqIndustries, jqOccupations, jqMainItems, jqRoles, jqPrice, jqArea, jqCountries, jqShows, jqIndustrieCategorys, jqMainItemCategorys, jqNextJoinsJqXHR, jqpurposeOptions, jqRegistRoute, jqInvitationType) => {
      const prefectures: Prefectures[] = jqPrefectures[0];
      const industries: Industries[] = jqIndustries[0];
      const occupations: Occupations[] = jqOccupations[0];
      const mainItems: MainItems[] = jqMainItems[0];
      const roles: Roles[] = jqRoles[0];
      const price: Price[] = jqPrice[0];
      const area: Area[] = jqArea[0];
      const countries: Countries[] = jqCountries[0];
      const shows: Shows[] = jqShows[0];
      const industrieCategorys: IndustrieCategorys[] = jqIndustrieCategorys[0];
      const mainItemCategorys: MainItemCategorys[] = jqMainItemCategorys[0];
      const nextjoins: Nextjoins[] = jqNextJoinsJqXHR[0];
      const purposeOptions: PurposeOptions[] = jqpurposeOptions[0];
      const registRoutes: RegistRoutes[] = jqRegistRoute[0];
      const invitationType: InvitationType[] = jqInvitationType[0];

      // 個人情報保護
      let note2URL: string =
        '<a href="'+ t.note2URL[lang] + '" style="display: inline;" target="_blank">' + t.note2[lang] + '</a>';
      $('#note2URL').html(note2URL);

      // 個人情報保護
      let note4URL: string =
        '<a href="'+ t.note4URL[lang] + '" style="display: inline;" target="_blank">' + t.note4[lang] + '</a>';
      $('#note4URL').html(note4URL);

      // 都道府県
      let prefectureList: string =
        '<option value="">' + t.preftop[lang] + '</option>';
      prefectures.forEach((item) => {
          prefectureList += `<option value="${item.prefectureIndex}">${item.prefecture}</option>`;
      });
      $('#prefectureIndex').html(prefectureList);

      // 業種カテゴリー
      let industrieCategoryList: string =
      '<option value="">' + t.induscatetop[lang] + '</option>';
      industrieCategorys.forEach((item) => {
        industrieCategoryList += `<option value="${item.industryCategoryValueIndex}">${item.industryCategoryValue}</option>`;
      });
      $('#industryCategory').html(industrieCategoryList);

      // 業種
      let industrieList: string =
      '<option value="">' + t.industop[lang] + '</option>';
      industries.forEach((item) => {
          industrieList += `<option value="${item.industryValueIndex}">${item.industryValue}</option>`;
      });
      $('#industryValueIndex').html(industrieList);

      // 主力商品カテゴリー
      let mainItemCtegoryList: string =
      '<option value="">' + t.itemcatetop[lang] + '</option>';
      mainItemCategorys.forEach((item) => {
        mainItemCtegoryList += `<option value="${item.mainItemCategoryValueIndex}">${item.mainItemCategoryValue}</option>`;
      });
      $('#mainItemCategory').html(mainItemCtegoryList);

      // 主力商品
      let mainItemList: string =
      '<option value="">' + t.itemtop[lang] + '</option>';
      mainItems.forEach((item) => {
          mainItemList += `<option value="${item.mainItemValueIndex}">${item.mainItemValue}</option>`;
      });
      $('#mainItemValueIndex').html(mainItemList);

      // 職種
      let occupationList: string =
      '<option value="">' + t.occutop[lang] + '</option>';
      occupations.forEach((item) => {
          occupationList += `<option value="${item.occupationIndex}">${item.occupation}</option>`;
      });
      $('#occupationIndex').html(occupationList);

      // 購買決定権
      let roleList: string =
      '<option value="">' + t.roletop[lang] + '</option>';
      roles.forEach((item) => {
          roleList += `<option value="${item.decisionRightValueIndex}">${item.decisionRightValue}</option>`;
      });
      $('#decisionRightValueIndex').html(roleList);

      // 購買決定額
      let priceList: string =
      '<option value="">' + t.pricetop[lang] + '</option>';
      price.forEach((item) => {
          priceList += `<option value="${item.decisionPriceValueIndex}">${item.decisionPriceValue}</option>`;
      });
      $('#decisionPriceValueIndex').html(priceList);

      // 居住地域
      let areaList: string = "";
      let checked: string = "checked";
      area.forEach((item) => { // できれば最初の値挿入時だけselectedをついかして初期値日本になるように
          areaList += `<div class='class="custom-control custom-radio is-invalid'><label class='radio_tate'><input class="confdis" value="${item.areaIndex}" type="radio" name="areaIndex" ${checked}> ${item.area}</label></div>`;
          if( checked ) checked = "";
      });
      $('#areaIndexbox').html(areaList);// バリューでyes.noを何とかして追加

      // 国
      let countriesList: string =
      '<option value="">' + t.countriestop[lang] + '</option>';
      countries.forEach((item) => {
          countriesList += `<option value="${item.countryIndex}" >${item.country}</option>`;
      });
      $('#countryIndex').html(countriesList);

      // 次回出展検討
      let nextjoinsList: string =
        '<option value="">' + t.Areconsideringval[lang] + '</option>';
        nextjoins.forEach((item) => {
          nextjoinsList += `<option value="${item.next_join_id}">${item.next_join_text}</option>`;
      });
      $('#nextjoin').html(nextjoinsList);

      // 来場目的
      let purposeOptionsList: string = "";
      let intitem = 1;
      purposeOptions.forEach((item) => {
        purposeOptionsList += `<div class="notgift">
        <input type="checkbox" class="check confdis" id="purpose${intitem}" name="purpose" value="${item.purpose_option_id}">
        <label class="trn" data-trn-key="purpose${intitem}" for="purpose${intitem}">${item.purpose_option_text}</label>
        </div>`;
        intitem += 1;
      });
      $('#notgift').html(purposeOptionsList);

      // どこで知りましたか
      let registRouteList: string =
        '<option value="">' + t.select[lang] + '</option>';
      registRoutes.forEach((item) => {
          registRouteList += `<option value="${item.route_id}">${item.route_name}</option>`;
      });
      $('#registRouteIndex').html(registRouteList);

      // 招待状の種類
      let invitationTypeList: string =
      '<option value="">' + t.select[lang] + '</option>';
      invitationType.forEach((item) => {
          invitationTypeList += `<option value="${item.invitation_type_id}">${item.invitation_type_text}</option>`;
      });
      $('#invitationTypeIndex').html(invitationTypeList);
      
    })
    .fail(() => {
      var result = window.confirm(t.api_fail[lang]);
      if( result ) {
        location.reload();
      }
    })
    .always(() => {
      
      translate(); // 翻訳
      $('#loading').hide(); // ロードを解除
    });

  // バリデーションチェック
  const validationCheck = () => {
    let confFlg : boolean  = false;
    let forms = document.getElementsByClassName('needs-validation');
    Array.prototype.filter.call(forms, function (form) {
      signUpValidation(form);
      if (form.checkValidity() === false) {
        form.classList.add('was-validated');
        const firstelement = document.querySelector<HTMLElement>('input:invalid, checkbox:invalid, radio:invalid, select:invalid');
        if (firstelement) firstelement.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        confFlg = true;
      }
    });
    return confFlg;
  };

  //  データ送信
  const dataSend = (procFlag: number) => {
    // 画面データ読み込み

    // ご来場予定見本市
    let willvisit:string[] = [];
    if(exhibition === "giftnet"){
    }else{
      willvisit.push(exhibition)
    }

    // 来場目的
    let purpose : string = "";
    for (var i = 0; i < $('input[name=purpose]').length; i++) {
      if ($(`#purpose${i+1}`).prop('checked')) {
        if(purpose === ""){
          purpose = String(i+1);
        }else{
          purpose = purpose + `-${String(i+1)}`;
        }
      }
    }

    let countryIndex = 81; // 国：日本
    let prefectureIndex = 48;// 都道府県：海外
    let invitationTypeIndex = 2; // 招待状タイプ：電子のみ
    if( Number($('input[name=areaIndex]:checked').val()) == 1 ){
      // 日本
      prefectureIndex = $('#prefectureIndex').val() as number;
      invitationTypeIndex = $('#invitationTypeIndex').val() as number;
    }else{
      // 日本以外
      countryIndex = $('#countryIndex').val() as number;
    }

    var purposeCodeArr: number[] = [];
    $("#notgift input:checkbox:checked").map(function(){
      purposeCodeArr.push($(this).val() as number)
    });
    
    // APIに送信するデータを入れ込む
    const datasend = (): dataSend => ({
      smsToken: smsToken,
      procFlag: procFlag,
      userFlag: Number(vipParam as string),
      code: codeParam as string,
      lang: lang,
      share_code: localStorage.getItem('share_code') as string,
      email: $('#email').val() as string,
      familyName: $('#familyName').val() as string,
      givenName: $('#givenName').val() as string,
      familyNameKana: $('#familyNameKana').val() as string,
      givenNameKana: $('#givenNameKana').val() as string,
      companyName: $('#companyName').val() as string,
      companyNameKana: $('#companyNameKana').val() as string,
      department: $('#department').val() as string,
      position: $('#position').val() as string,
      areaIndex: Number($('input[name=areaIndex]:checked').val()),
      countryIndex: countryIndex,
      zipCode: $('#zipCode').val() as string,
      prefectureIndex: prefectureIndex,
      city: $('#city').val() as string,
      houseNumber: $('#houseNumber').val() as string,
      building: $('#building').val() as string,
      emergencyContactValue: $('#phoneNumber').val() as string,
      phoneNumber: $('#companyPhoneNumber').val() as string,
      industryValueIndex: Number($('#industryValueIndex').val()),
      industryCategory: Number($('#industryCategory').val()),
      industryOtherText: $('#industryOtherText').val() as string,
      mainItemValueIndex: Number($('#mainItemValueIndex').val()),
      mainItemCategory: Number($('#mainItemCategory').val()),
      mainItemOtherText: $('#mainItemOtherText').val() as string,
      occupationIndex: Number($('#occupationIndex').val()),
      decisionRightValueIndex: Number($('#decisionRightValueIndex').val()),
      decisionPriceValueIndex: Number($('#decisionPriceValueIndex').val()),
      nextJoinId: Number($('#nextjoin').val()),
      purposeOptionsIndex : purpose,
      purposeCode: purposeCodeArr,
      foreignItemIndex: $('input[name=abroad]:checked').val() == "yes" ? 1 : 0,
      invitationType: invitationTypeIndex,
      //hopeEmailPush: $('input[name=mail_subscription]:checked').val()  == "yes" ? 1 : 0,
      //mailGuidanceIndex: $('input[name=dm_subscription]:checked').val()  == "yes" ? 1 : 0,
      subscribeIndex : $('input[name=monthly]:checked').val()  == "yes" ? 1 : 0,
      applyList: willvisit,
      route_id: Number($('#registRouteIndex').val()),
      tenji_key: exhibition
    });

    if (procFlag === proc.check){
      // 確認画面処理 
      // コントロール無効化
      $('.confread').prop('readonly', true); 
      $('.confdis').prop('disabled', true);
      $('.confbtnA').hide();
      $('.confbtnB').show();
      $('.step1').hide();
      $('.step2').show();
      $('body, html').scrollTop(0);
    } else if(procFlag === proc.set){
      $('#registbtn').prop('disabled', true);
        dataSendJqXHR(datasend())
      .done((data) => {
        if(data.type === "success"){
          window.location.href = './thanks.html';
        }
      })
      .fail((jqXHR) => {
        // バックエンドからのエラー
        // console.log("APIエラー:"+jqXHR['responseJSON']['errors']); 
        let noid :string = "";
        $.each(jqXHR['responseJSON']['errors'], (index, value) => {
          let id = index as string;
          if (!($('#' + id).length)) {
            // IDなし
            noid += value[0]+"<br>";
          }else{
            // IDがあるコントロールのエラー表示
            const element: HTMLInputElement = <HTMLInputElement>document.getElementById(id);
            if (element.nextElementSibling) element.nextElementSibling.innerHTML = "※"+value[0];
            element.classList.add('is-invalid');

            if (index == "email") {
              // 登録済みEmailエラー表示
              $("#emailerrmsg").attr("href", process.env.GIFT_NET_URL + "registration/login.html")
              $("#emailerrmsg").text(t.emailerrmsg[lang]);
              $("#emailerrmsg").show();
              element.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }
        });
        if(noid) {
          // IDがないエラー表示
          $('#errbox').html(noid);
          $('#errbox').show();
        }
      })
      .always(() => {
        $('#registbtn').prop('disabled',false);
      });
    }
  }

  // 確認ボタン押下イベント
  $('#submitbtn').on('click', () => {
    if (validationCheck()){
      dataSend(proc.check);
      $('.invalid-feedback').hide();
      $('.js-mail-error').remove();
      $('#email').removeClass("is-invalid");
    }
  });

  // 戻るボタン押下イベント
  $('#returnbtn').on('click', () => {
      $('.confread').prop('readonly',false);
      $('.confdis').prop('disabled',false);
      $('#registbtn').prop('disabled',false);
      $('.confbtnA').show();
      $('.confbtnB').hide();
      $('.step2').hide();
      $('.step1').show();
      $('body, html').scrollTop(0);
  });

  // 登録ボタン押下イベント
  $('#registbtn').on('click', () => {
    $('#registbtn').prop('disabled',true); // ボタンを無効にする
    if (validationCheck()){
      dataSend(proc.set);
    }else{
      $('#registbtn').prop('disabled',true); // ボタンを有効にする
    }
  });

  // 登録ボタン押下ダブルクリックイベント
  $('#registbtn').on('dblclick', () => {
    // スルー何もしない
  });

  // 業種カテゴリーを選択
  $('#industryCategory').on('change', () => {
    if ($('#industryCategory').val() as number > 0) {
      $('#industryValueIndex').prop('disabled', false);
      // 業種API
      getIndustriesJqXHR($('#industryCategory').val() as number)
        .done((data, textStatus, jqXHR) => {
          const industries: Industries[] = data;
          let industrieList: string =
          '<option value="">' + t.industop[lang] + '</option>';
          industries.forEach((item) => {
            if (item.showFlg === "yes"){
              industrieList += `<option value="${item.industryValueIndex}">${item.industryValue}</option>`;
            }
          });
          $('#industryValueIndex').html(industrieList);
        })
        .fail((jqXHR, textStatus, errorThrown) => {
          alert("業種取得失敗");
        });
    } else {
      $('#industryValueIndex').prop('disabled', true);
    }
  });

  // 業種その他が選択されたときその他フォームを出す
  $('#industryValueIndex').on('change', () => {
    if ($('#industryValueIndex').val() === '99') {
      $('.js-industry-other').show();
      $('.js-industry-other input').prop('required', true);
    } else {
      $('.js-industry-other').hide();
      $('.js-industry-other input').prop('required', false);
    }
  });

  // 主力商品カテゴリーを選択
  $('#mainItemCategory').on('change', () => {
    if ($('#mainItemCategory').val() as number > 0) {
      $('#mainItemValueIndex').prop('disabled', false);
      // 主力商品API
      getMainItemsJqXHR($('#mainItemCategory').val() as number)
        .done((data, textStatus, jqXHR) => {
          const mainitems: MainItems[] = data;
          let mainItemList: string =
          '<option value="">' + t.itemtop[lang] + '</option>';
          mainitems.forEach((item) => {
            if (item.showFlg === "yes"){
            mainItemList += `<option value="${item.mainItemValueIndex}">${item.mainItemValue}</option>`;
            }
          });
          $('#mainItemValueIndex').html(mainItemList);
        })
        .fail((jqXHR, textStatus, errorThrown) => {
          alert("主力商品取得失敗");
        });
    } else {
      $('#mainItemValueIndex').prop('disabled', true);
    }
  });
  // 主力商品その他が選択されたときその他フォームを出す
  $('#mainItemValueIndex').on('change', () => {
    if ($('#mainItemValueIndex').val() === '99') {
      $('.js-product-other').show();
      $('.js-product-other input').prop('required', true);
    } else {
      $('.js-product-other').hide();
      $('.js-product-other input').prop('required', false);
    }
  });

  // ajax終了後処理
  $(document).ajaxStop(function() {
      // 居住地域の選択で違うフォームを出す
      $('input[name=areaIndex]').on('change', () => {
        if ($('input[name=areaIndex]:eq(0)').prop('checked')) {
          $('.country').hide();
          $('.prefecture').show();
          $('#countryIndex').prop('required', false);
          $('#prefectureIndex').prop('required', true);
          $('#zipCode').prop('pattern', '^[0-9-]*$');
          $('#zipCode').attr('data-pattern-replace', '[^0-9-]+');
          $('#zipCode').val('');
          $('#invitationTypeIndex').prop('required', true);
          $('.invitation-type').show();
        } else {
          $('.country').show();
          $('.prefecture').hide();
          $('#countryIndex').prop('required', true);
          $('#prefectureIndex').prop('required', false);
          $('#zipCode').prop('pattern', '^[a-zA-Z0-9-]*$');
          $('#zipCode').attr('data-pattern-replace', '[^a-zA-Z0-9-]+');
          $('#zipCode').val('');
          $('#invitationTypeIndex').prop('required', false);
          $('.invitation-type').hide();
        }
      });
  });
  
  $(document).ajaxStop(function () {
    //====================
    //チェックボックス必須化
    //====================
    //チェックしたら発火
    $('.check').on('change', (event) => {

      //選択したinputのname値を変数に格納
      let name = <string>event.target.getAttribute('name');

      //control用のIDを連結
      let control_name = name + '_control';

      //チェックされているチェックボックスの数が0より多い場合
      if ($("input[name='" + name + "']:checked").length > 0) {
        //チェック有効
        $("#" + control_name).prop('checked', true);
      } else {
        //チェック有効
        $("#" + control_name).prop('checked', false);
      }
    });

    // Gift Netの閲覧（来場予定はあとで選ぶ）※マイページよりご変更いただけますがチェックされたら来場予定見本市のチェックを外す
    $('.js-only-registration').on('change', () => {
      $('.js-will-visit').prop('checked', false);
    });

    // 来場予定見本市がチェックされたらGift Netの閲覧（来場予定はあとで選ぶ）※マイページよりご変更いただけますのチェックを外す
    $('.js-will-visit').on('change', () => {
      $('.js-only-registration').prop('checked', false);
    });

    // 出展は検討していないがチェックされたら出展検討見本市のチェックを外す
    $('#nextjoin_yes').on('change', () => {
      $('.js-next-join').prop('disabled', false);
      $('#nextjoin_control').prop('checked', false);
      $('.js-next-join').show();
      $('.js-next-text').show();
      $('.Consnextexhibition').show();
    });

    // 出展は検討していないがチェックされたら出展検討見本市のチェックを外す
    $('#nextjoin_no').on('change', () => {
      $('.js-next-join').prop('checked', false);
      $('.js-next-join').prop('disabled', true);
      $('#nextjoin_control').prop('checked', true);
      $('.js-next-join').hide();
      $('.js-next-text').hide();
      $('.Consnextexhibition').hide();
    });

    // 出展検討見本市がチェックされたら出展は検討していないのチェックを外す
    $('.js-next-join').on('change', () => {
        $('.js-non-consideration').prop('checked', false);
      });
    });

  $('#loading').hide(); // ロードを解除

});